import gql from 'graphql-tag';
import insurtechCommonFragments from '../fragments/insurtech.common.fragments';
import insurtechBasicFragments from '../fragments/insurtech.basic.fragments';

const INSURTECH_WP_QUERY = gql`
    query ShopInsurtechLegacyCheckout(
        $context: ContextInput!
        $searchCriteria: InsurtechOfferSearchCriteriaInput!
        $clientMetaData: InsurtechClientMetaDataInput!
        $propertyDetails: InsurtechPropertyDetailsInput!
    ) {
        shopInsurtechLegacyCheckout(
            context: $context
            searchCriteria: $searchCriteria
            propertyDetails: $propertyDetails
            clientMetaData: $clientMetaData
        ) {
            modules {
                ...WeatherPromiseModuleFragment
            }
            pageLevelInfo {
                dialogs {
                    ...InsurtechDialogFragment
                }
            }
        }
    }
    ${insurtechCommonFragments.WeatherPromise.Module}
    ${insurtechCommonFragments.WeatherPromise.Dialog}
`;

const INSURTECH_SHOPPING_QUERY = gql`
    query ShopInsurtechLegacyCheckout(
        $context: ContextInput!
        $clientMetaData: InsurtechClientMetaDataInput!
        $insurtechComponentPlacement: InsurTechComponentPlacementInput
        $shoppingCriteria: InsurtechShoppingCriteriaInput
    ) {
        shopInsurtechLegacyCheckout(
            context: $context
            clientMetaData: $clientMetaData
            insurtechComponentPlacement: $insurtechComponentPlacement
            shoppingCriteria: $shoppingCriteria
        ) {
            modules {
                ...InsurtechShoppingModuleFragment
            }
            pageLevelInfo {
                dialogs {
                    ...InsurtechDialogFragment
                }
            }
            testimonial {
                ...InsurTechTestimonialFragment
            }
            disclaimer {
                disclaimers
            }
        }
    }
    ${insurtechCommonFragments.InsurtechShoppingModule.Module}
    ${insurtechCommonFragments.WeatherPromise.Dialog}
    ${insurtechBasicFragments.Testimonial}
`;

export default {INSURTECH_WP_QUERY, INSURTECH_SHOPPING_QUERY};
